import { render, staticRenderFns } from "./request-config-dialog.vue?vue&type=template&id=51ffe59d&"
import script from "./request-config-dialog.vue?vue&type=script&lang=js&"
export * from "./request-config-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports